function headerScroll(){
	if($('.wrap')[0].getAttribute('data-page') == 'service__index'){
		var n = $(window).height()*1.2;
	}else{
		var n = 300;
	}
	if($('.section--work__detail').hasClass('is--work__detail')){
		$('.header').addClass('is--scroll');
	}
	$(window).on('scroll', function(){
		var top = $(window).scrollTop();

		if(top > n){
			$('.header').addClass('is--scroll');
		}else if(top <= n &&!($('.section--work__detail').hasClass('is--work__detail'))){
			$('.header').removeClass('is--scroll');
		}
	});
}

module.exports = headerScroll;




// WEBPACK FOOTER //
// ./es2015/module/_header_scroll.js